module.exports = __webpack_public_path__ + "img/imgZXGH(19).0f32de86.png";